import React, { useEffect, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
function Root() {
  useEffect(() => {
    // Set page title
    document.title = 'Método ANCLA by HAE';
    // Meta Pixel Base Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];
      t=b.createElement(e);t.async=!0;
      t.src=v;
      s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}
      (window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1588595258841964');
      fbq('track', 'PageView');
      fbq('track', 'ViewContent');
    `;
    document.head.appendChild(script);
  }, []);
  return <App data-id="element-3" />;
}
render(<Root data-id="element-4" />, document.getElementById('root'));